import { render, staticRenderFns } from "./quiz-list.vue?vue&type=template&id=54ef4ef0&scoped=true"
import script from "./quiz-list.vue?vue&type=script&lang=js"
export * from "./quiz-list.vue?vue&type=script&lang=js"
import style0 from "./quiz-list.vue?vue&type=style&index=0&id=54ef4ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef4ef0",
  null
  
)

export default component.exports